import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import "./Register.styled";
import {
  LoginContainer, GraphicSide, FormSide, LoginForm, InputGroup, Input, Button, CheckboxContainer, Checkbox, Label, BackgroundImage, LogoContainer, BackgroundImageContainer, RegisterTitle,
  BackButton, LoginLink, Logo, WelcomeContainer
} from "./Register.styled";
import { useUser } from "../../hooks";
import { checkToken } from "../../repositories/utils";
import tennisCourt from "../../static/tennis_court.webp";
import LogoImage from "../../static/logo_white.svg";

export const Register = (props) => {
  const { createUser } = useUser()
  const [formValues, setFormValues] = useState({ email: '', name: '', surname: '', terms: false });
  const { t } = useTranslation();

  useEffect(() => {
    if (checkToken()) props.history.push('/home/logged');
  }, [props.history]);

  const registerUser = async (values) => {
    const userData = {
      email: values.email,
      name: values.name,
      surname: values.surname,
    };
    try {
      await createUser(userData);
      props.history.push('/check');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Registration failed:", error);
    }
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleCheckboxChange = (event) => {
    setFormValues({
      ...formValues,
      terms: event.target.checked
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formValues.terms && formValues.email && formValues.name && formValues.surname) {
      registerUser(formValues);
    } else {
      // eslint-disable-next-line no-console
      console.log("Form validation failed: Please fill all fields and accept terms.");
    }
  };

  return (
    <LoginContainer>
      <FormSide>
        <BackButton onClick={() => props.history.push('/login')}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          {t('back')}
        </BackButton>

        <LogoContainer>
          <Logo src={LogoImage} alt="Company Logo" />
        </LogoContainer>

        <WelcomeContainer>
             <RegisterTitle>{t('accountRegistration')}</RegisterTitle>
        </WelcomeContainer>

        <LoginForm onSubmit={handleSubmit}>
          <InputGroup>
            <Input type="email" name="email" placeholder={t('email') || 'Email'} required onChange={handleInputChange} value={formValues.email}/>
          </InputGroup>
          <InputGroup>
            <Input type="text" name="name" placeholder={t('name') || 'Name'} required onChange={handleInputChange} value={formValues.name} autoComplete="given-name" />
          </InputGroup>
          <InputGroup>
            <Input type="text" name="surname" placeholder={t('surname') || 'Surname'} required onChange={handleInputChange} value={formValues.surname} autoComplete="family-name" />
          </InputGroup>
          <InputGroup>
            <CheckboxContainer>
              <Checkbox id="terms-checkbox" type="checkbox" name="terms" required checked={formValues.terms} onChange={handleCheckboxChange} />
              <Label>
                  <Trans
                    i18nKey="terms"
                    components={[<a target="_blank" rel="noreferrer" href="/terms" />]}
                  >
                  </Trans>
                </Label>
            </CheckboxContainer>
          </InputGroup>
          <InputGroup>
            <Button type="submit" disabled={!formValues.terms || !formValues.email || !formValues.name || !formValues.surname}>
                {t('register')}
            </Button>
          </InputGroup>
          <LoginLink>
            {t('alreadyHaveAccount') || 'Already have an account?'} <Link to="/login">{t('login') || 'Log In'}</Link>
          </LoginLink>
        </LoginForm>
      </FormSide>
      <GraphicSide>
        <LogoContainer className="mobile-logo">
            <Logo src={LogoImage} alt="Company Logo Mobile" />
        </LogoContainer>
        <BackgroundImage src={tennisCourt} alt={t('tennisCourtAlt') || "Tennis court background"} />
      </GraphicSide>
    </LoginContainer>
  );
};
